export default class UtilSort{

     static ascending(array = []) {
        return [...array].sort((a, b) =>
            a.localeCompare(b, 'pt-BR', {
                numeric: true,
                sensitivity: 'base',
            })
        );
    }

    static descending(array = []) {
        return [...array].sort((a, b) =>
            b.localeCompare(a, 'pt-BR', {
                numeric: true,
                sensitivity: 'base',
            })
        );
    }

    static ascendingBy(array = [], property) {
        return [...array].sort((a, b) =>
            a[property].localeCompare(b[property], 'pt-BR', {
                numeric: true,
                sensitivity: 'base',
            })
        );
    }

    static descendingBy(array = [], property) {
        return [...array].sort((a, b) =>
            b[property].localeCompare(a[property], 'pt-BR', {
                numeric: true,
                sensitivity: 'base',
            })
        );
    }

}